import { Delete } from "@mui/icons-material";
import {
  Box,
  Button,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import AlertDialog from "Components/AlertDialog/AlertDialog";
import { useContext, useState } from "react";
import { VishcorpSettingsContext } from "../context";
import { deleteVehicleType } from "./functions";
import NewVehicleType from "./NewVehicleType";

export default function VehicleType(props) {
  const { organizationSettings, updateOrganizationSettings } = useContext(
    VishcorpSettingsContext
  );

  const organizationID = organizationSettings?.organizationID;
  const vehicleTypes = organizationSettings?.vehicleTypes;
  const [openNewVehicleType, setOpenNewVehicleType] = useState(undefined);
  const [confirmDelete, setConfirmDelete] = useState(undefined);
  const [selectedVehicleType, setSelectedVehicleType] = useState(undefined);

  return (
    <Box sx={{ display: "flex", height: "100%" }}>
      <Paper sx={{ padding: 2, marginLeft: 1, flexGrow: 1 }}>
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <Typography variant="h5">{`Vehicle Types`}</Typography>
          <Button
            onClick={() => setOpenNewVehicleType(true)}
            variant="contained"
          >
            New Vehicle Type
          </Button>
        </div>
        <br />
        <TableContainer
          component={Paper}
          style={{ height: "50vh", overflow: "scroll" }}
        >
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>
                  <b>Package Type</b>
                </TableCell>
                <TableCell></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {vehicleTypes?.length > 0 &&
                vehicleTypes?.map((e) => (
                  <TableRow>
                    <TableCell>{e?.name}</TableCell>
                    <TableCell>
                      <IconButton
                        onClick={() => {
                          setSelectedVehicleType(e);
                          setConfirmDelete(true);
                        }}
                      >
                        <Delete />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
      <AlertDialog
        customControls={false}
        open={openNewVehicleType}
        handleClose={() => setOpenNewVehicleType(false)}
        // dialogTitle={`New ${label} Attribute`}
        dialogContent={
          <NewVehicleType
            handleClose={() => setOpenNewVehicleType(false)}
            organizationID={organizationID}
            onRefresh={updateOrganizationSettings}
          />
        }
      />
      <AlertDialog
        // customControls={false}
        open={confirmDelete}
        handleClose={() => setConfirmDelete(false)}
        handleConfirm={async () => {
          await deleteVehicleType(
            organizationID,
            selectedVehicleType?.name,
            organizationSettings?.organizationTablePrefix
          );
          setConfirmDelete(false);
          updateOrganizationSettings();
        }}
        dialogTitle={`Delete Vehicle Type: ${selectedVehicleType?.name}?`}
      />
    </Box>
  );
}
